import { Col, Row } from 'react-bootstrap'

const WantToLearn = () => (
    <>
    <div className="section-want-to-learn">
        <Row className="clearfix">
            <Col lg={6} md={7} className="left-content">
                <h2>You want to learn <br/>
                the <em>basics</em> of building health through nutrition.</h2>
                <p>This is why this report is so important. Having a basic knowledge of building and maintaining health through natural nutrition can have amazing life changing results.</p>
                <p>And the fact is, your Doctor is unlikely to be able to help you on this topic.</p>
                <p>Unfortunately nutrition is a massive subject and you could easily take years trying to study the many facets of it. But let's face it, You don't have time to wait that long. </p>
                <p>This report has been distilled down to give you a core understanding of what you need to know about nutrition so you can become proactive about preserving the health you have.</p>
            </Col>
        </Row>
    </div>
    <style jsx global>{`

            .section-want-to-learn {
                background: url(../images/wyd/bg-playing-baseball01.jpg) no-repeat center right;
                font-size: 20px;
            }

            .section-want-to-learn .left-content {
                background: #fbf9fc;
                padding: 65px 15px 60px 15px; 
            }

            .section-want-to-learn h2 {
                color: #00aec7;
                font-size: 42px;
                margin-bottom: 35px;
                letter-spacing: 1px;
            }

            .section-want-to-learn p {
                margin-bottom: 40px;
                line-height: 36px;
            }

            @media (min-width: 1590px) {

                .section-want-to-learn .left-content {
                    padding: 65px 30px 60px 260px; 
                }

            }

            @media (max-width: 767.98px) {	

                .section-want-to-learn {
                    background-size: cover;
                }

                .section-want-to-learn h2 {
                    font-size: 32px;
                    margin-bottom: 25px;
                }

                .section-want-to-learn .left-content {
                    background: rgba(251,249,252,.9);
                    padding: 30px 15px 30px 15px; 
                }

            }

        `}</style>
    </>
);

export default WantToLearn;